import { render } from "./ModalRecoverConfirmation.vue?vue&type=template&id=ab1d2dce"
import script from "./ModalRecoverConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalRecoverConfirmation.vue?vue&type=script&lang=js"

import "./ModalRecoverConfirmation.vue?vue&type=style&index=0&id=ab1d2dce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__